var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"height":"560px","width":"100%"},attrs:{"id":"adobe-dc-view"}})
}
var staticRenderFns = []

export { render, staticRenderFns }